import React, { useEffect, useState } from 'react';
import { getBrowserTimeZone } from 'web/components/timezone/timeZoneUtils';
import useErrorReporter from 'web/hooks/useErrorReporter';

// Best-effort country used to preselect form defaults. It is derived from the browser time zone,
// so it needs no network request; users can always change the preselected value.
const GeoIpContext = React.createContext<introwise.GeoIP | null>(null);

const GeoIpProvider = ({ children }: { children: React.ReactNode }) => {
  const errorReporter = useErrorReporter();
  const [geoIp, setGeoIp] = useState<introwise.GeoIP | null>(null);

  useEffect(() => {
    let active = true;
    const detectCountry = async () => {
      try {
        const { getCountryCode } = await import('@vvo/tzdb');
        const countryCode = getCountryCode(getBrowserTimeZone());
        if (active && countryCode) {
          setGeoIp({ countryCode });
        }
      } catch (err) {
        errorReporter.report(new Error(`Failed to detect a country from the browser time zone: ${err}`));
      }
    };
    detectCountry();
    return () => {
      active = false;
    };
  }, [errorReporter]);

  return <GeoIpContext.Provider value={geoIp}>{children}</GeoIpContext.Provider>;
};

export { GeoIpProvider };
export default GeoIpContext;
